export const priceFields = /* GraphQL */ `
  fragment priceFields on Price {
    original
    current
    color
  }
`
